<div class="video-frame">
    <video #videoPlayer controls playsinline preload="metadata"
        (error)="onError()" (loadeddata)="onLoaded()" (play)="onPlayingChange(true)" (pause)="onPlayingChange(false)" (ended)="onPlayingChange(false)">
        <source [src]="fullVideoUrl" type="video/mp4" (error)="onError()">
        Your browser can't play this video.
    </video>
    @if (loading && !failed) {
        <div class="loading" aria-live="polite">
            <mat-spinner diameter="32"></mat-spinner>
            <span>Loading video…</span>
        </div>
    }
</div>
@if (failed) {
    <p class="error" role="alert">The video couldn't be loaded. Check your connection and try again.</p>
}
@if (showRestart || failed) {
    <div class="buttons-container">
        <button mat-stroked-button (click)="restart()" [disabled]="!videoUrl">
            <mat-icon>{{failed ? 'refresh' : 'restart_alt'}}</mat-icon>
            {{failed ? 'Try again' : 'Start again'}}
        </button>
    </div>
}
